// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoiceSchema = z.object({
  id: z.number().int().describe("Unique identifier for the invoice"),
  user: z.object({}).describe("User who created the invoice"),
  account_id: z.number().int().describe("Account ID"),
  name: z.coerce.string().describe("Invoice name").nullish(),
  description: z.coerce.string().describe("Invoice description").nullish(),
  date: z.string().date().describe("Invoice date").nullish(),
  from: z.string().date().describe("Start date for invoice period").nullish(),
  to: z.string().date().describe("End date for invoice period").nullish(),
  paid: z.boolean().describe("Whether the invoice has been paid"),
  invoice_by: z.coerce.string().describe("Invoice grouping method").nullish(),
  list_item_grouping: z.coerce.string().describe("Line item grouping method").nullish(),
  total_cost: z.object({}).describe("Total cost"),
  total_hours: z.object({}).describe("Total hours"),
  created_at: z.string().datetime().describe("Creation timestamp"),
  updated_at: z.string().datetime().describe("Last update timestamp"),
  deleted: z.boolean().describe("Whether the invoice is deleted"),
  external_references: z.array(z.object({})).describe("External system references"),
  status: z.coerce.string().describe("Invoice status").nullish(),
  external_total_cost: z.object({}).describe("External total cost"),
  due_date: z.string().date().describe("Due date").nullish(),
  project: z.object({}).describe("Associated project").nullish(),
  client: z.object({}).describe("Associated client").nullish(),
  lines: z.optional(z.array(z.object({})).describe("Invoice line items")),
  filters: z.optional(z.object({}).describe("Invoice filters")),
});
